<template>
    <div>
        <!--div :class="backgroundStyle" @click="cancelEdit"/-->
        <div class="dialog" style="display: none; position: fixed !important;" id="tagSelect">
            <div v-for="item in memberTags" :key="item.userId" class="item" @click="tagUser(item)">
                <div>{{item.fullName}}</div>
            </div>
        </div>
        <v-dialog v-model="editting" width="600px" style="width:600px;" id="postDialog" retain-focus persistent>
            <v-card>
                <v-card-text>
                    <div style="padding-bottom: 10px; background-color: white">
                        <div style="display: flex">
                            <!--img :src="user.avatar" class="mediumAvatar" style="display: flex"/-->
                            <i-avatar :user-id="user.userId" size="smallAvatar" style="display: flex"/>
                            <div class="postCreator" style="margin:auto 0px;font-size: 20px">{{user.fullName}}</div>
                        </div>
                        <div>
                            <v-select v-validate="'required'"
                                      label="Nội dung dành cho"
                                      v-model="receivers"
                                      name="receivers"
                                      key="receivers"
                                      data-vv-as="Nội dung dành cho"
                                      :multiple="true"
                                      :items="lstStudents"
                                      @change="onChangeReceivers"
                                      item-text="fullName"
                                      item-value="userId"
                                      :error-messages="errors.first('receivers')"
                            ></v-select>
                        </div>
                        <v-textarea :label="$t('lang.feed.pleasePost')" id="textArea"
                                    v-model="content"
                                    maxlength="1000" rows="10"
                                    @paste="onPaste"
                                    @keyup="onKeyDown"
                                    style="width: 100%;height: 200px;margin-top: 10px; position: relative"/>
                        <!--textarea id="textArea"
                                  v-model="content"
                                  maxlength="1000" rows="10"
                                  @paste="onPaste"
                                  @keyup="onKeyDown"
                                  style="width: 100%;height: 200px;margin-top: 10px; position: relative;border:1px solid red;top:10px"/-->

                        <v-text-field
                                :label="$t('lang.feed.tags')"
                                style="margin-top:15px"
                                v-model="tags"
                        ></v-text-field>

                        <div style="">
                            <div v-for="item in media" class="mediaPost">
                                <div class="delItem" @click="deleteAttach(item)"></div>
                                <img :src="item.url" :class="getClassOfImage(item)"
                                     v-if="item.type.indexOf('image/')>=0"/>
                                <video controls v-else-if="item.type.indexOf('image/')>=0">
                                    <source :src="item.url" :type="item.type">
                                    Your browser does not support the video tag.
                                </video>
                                <div v-else class="documentFile">
                                    <a :href="item.url">{{item.fileName}}</a>
                                </div>
                                <div class="mediaTitle"
                                     v-if="item.title != undefined && item.title != null && item.title !='' ">
                                    {{item.title}}
                                </div>
                            </div>
                        </div>
                        <div>
                            <v-btn light depressed round color="gray" @click="openFileDialog">
                                <v-icon color="royalblue">image</v-icon>
                                &nbsp {{$t('lang.feed.image_video')}}
                            </v-btn>
                            <input type="file" :id="'imageUpload'+objectType" style="display: none" class="file"
                                   @change="onFilePicked"
                                   :accept="accept"/>
                            <!--v-btn light depressed round color="gray">
                                <v-icon dark color="yellow">mood</v-icon>
                                &nbsp {{$t('lang.feed.emotion')}}
                            </v-btn-->
                        </div>
                        <div style="text-align: right">
                            <v-btn light depressed round dark class="red" @click="cancelEdit">
                                {{$t('lang.common.cancel')}}
                            </v-btn>
                            <v-btn light depressed round dark class="yoprimary" @click="postContent" v-if="editting">
                                {{$t('lang.class.post')}}
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showReceivers" width="600px">
            <v-data-table :headers="receiverHeaders" :items="receiverOfPost"
                          :pagination.sync="pagination"
                          class="elevation-1">
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.index+1 + parseInt(pagination.page-1) *
                        parseInt(pagination.rowsPerPage)}}
                    </td>
                    <td class="text-xs-left">{{ props.item.fullName }}</td>
                </template>
            </v-data-table>
        </v-dialog>
        <div>
            <div class="feed" style="padding-bottom: 10px;box-shadow: 5px 5px 5px rgba(0,0,0,0.2)" v-if="$store.state.auth.user.role==4">
                <div style="display: flex">
                    <!--img :src="user.avatar" class="mediumAvatar" style="display: flex"/-->
                    <i-avatar :user-id="user.userId" size="smallAvatar" style="display: flex"/>
                    <input :placeholder="$t('lang.feed.pleasePost')" id="postInput" class="postInput" v-model="content"
                           @click="editting=true" maxlength="1000"
                           @paste="onPaste" style="display: flex;flex-grow: 1"/>
                </div>
                <div class="postAction" style="margin-top:10px">
                    <v-btn light depressed round color="gray" @click="openFileDialog">
                        <v-icon color="royalblue">image</v-icon>
                        &nbsp {{$t('lang.feed.image_video')}}
                    </v-btn>
                </div>
            </div>
        </div>
        <div v-if="posts.length + topPosts.length>0">
            <div class="top-post" v-if="topPosts.length>0">
                <post :item="item" v-for="item in topPosts" :key="item.postId" :class-id="classId" @edit="onEdit"
                      @editComment="onEditComment" @view="onView" @report="onViewReport"
                      @exercise_report="onViewExercise"
                      @member="viewMember"
                      @reload="onReload"/>
            </div>
            <!--div style="border-bottom: 1px solid gray;width: 100%"></div-->
            <post :item="item" v-for="item in posts" :key="item.postId" :class-id="classId" @edit="onEdit"
                  @editComment="onEditComment" @view="onView" @report="onViewReport" @exercise_report="onViewExercise"
                  @member="viewMember"
                  @reload="onReload"/>
            <div v-if="posts.length == postCount" style="font-weight: bold;text-align: center;padding-top: 10px">
                Không có thêm bài viết nào
            </div>
            <v-progress-linear
                    indeterminate
                    color="pink"
                    v-else-if="posts.length < postCount"
            ></v-progress-linear>
        </div>
        <div v-else style="text-align: center">
            <div style="font-weight: bold">Bạn hãy chia sẻ với học viên tại đây:</div>
            <div>Chia sẻ kinh nghiệm</div>
            <div>Nhắc nhở, dặn dò học viên</div>
            <div>Up bài giảng, tài liệu</div>
        </div>
        <!--button class="yoprimary" @click="loadMore" style="width: 100%;margin-left:0px;margin-bottom: 25px">{{$t('lang.common.loadmore')}}</button-->
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import Post from "./post";

    export default {
        components: {Post, TeacherInfo, ClazzCreate},
        props: {
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },

        },

        computed: {
            styleOfFeed: function () {
                if (this.editting) {
                    return "feed active";
                } else {
                    return "feed";
                }
            },

            backgroundStyle: function () {
                if (this.editting) {
                    return "background show";
                } else {
                    return "background";
                }
            }
        },

        watch: {
            classId: function (data) {
                this.getTopPost();
                this.getPost();
            },

            editting: function (data) {
                if (!data) {
                    let d = document.getElementById("tagSelect");
                    d.style.display = "none";
                }
            }
        },

        data() {
            return {
                postCount: 0,
                topPosts: [],
                posts: [],
                editingPost: {},
                media: [],
                user: {},
                content: "",
                title: "",
                receivers: [0],
                showReceivers: false,
                receiverOfPost: [],
                postURL: null,
                postId: null,
                parentId: null,
                memberTags: [],
                tags: "",
                st: null,
                accept: "video/*,  video/x-m4v, video/webm, video/x-ms-wmv, video/x-msvideo, video/3gpp, video/flv, video/x-flv, video/mp4, video/quicktime, video/mpeg, video/ogv, .ts, .mkv, image/*, image/heic, image/heif, .docx,.doc,.xlsx,.xls,.pdf,.ppt,.pptx",
                lstStudents: [],
                fileContent: null,
                fileURL: null,
                fileName: null,
                fileType: null,
                editting: false,
                search: null,
                receiverHeaders: [
                    {
                        text: "STT",
                        align: "center",
                        search: false,
                        width: "20%",
                        sortable: false,
                        value: "name"
                    },
                    {
                        text: "Họ và tên",
                        align: "left",
                        sortable: false,
                        search: false,
                        width: "80%",
                        value: "fullName"
                    }
                ],
                workingComponent: null,
                page: 1,
                pageSize: 10,
                pagination: {
                    rowsPerPage: 10,
                    page: 1,
                    totalItems: 0,
                    orderBy: 'fullName',
                    descending: false
                },
            }
        },

        created() {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type == "common/setSearch") {
                    this.search = mutation.payload;
                    ////console.log(this.search);
                    this.getPost();
                }
            });

            this.user = this.$store.state.auth.user;
            if (this.$route.params.clzz) {
                this.cl = this.$route.params.clzz;
                //console.log("---post---");
                //console.log(this.cl);
            }
            this.getTopPost();
            this.getPost();
            this.getStudentOfClass();
        },

        beforeDestroy() {
            this.unsubscribe();
        },

        methods: {
            getStudentOfClass() {
                axios
                    .post(process.env.VUE_APP_API_URL + "/classmember/member?classId=" + this.classId)
                    .then(
                        data => {
                            this.lstStudents = data;
                            this.lstStudents.splice(0, 0, {
                                userId: 0,
                                fullName: "Tất cả"
                            })
                        },
                        error => {
                        }
                    );

            },


            onChangeReceivers() {
                //console.log(this.receivers);
                if (this.receivers[this.receivers.length - 1] == 0) {
                    this.receivers = [0];
                } else {
                    let arr = [];
                    for (let i = 0; i < this.receivers.length; i++) {
                        if (this.receivers[i] != 0) {
                            arr.push(this.receivers[i]);
                        }
                    }
                    this.receivers = arr;
                }
            },

            postContent: function () {
                if (this.content.trim().length == 0) {
                    return;
                }
                let receivers = "";
                for (let i = 0; i < this.receivers.length; i++) {
                    if (receivers == "") {
                        receivers = this.receivers[i];
                    } else {
                        receivers += "," + this.receivers[i];
                    }
                }
                let post = {
                    classId: this.classId,
                    title: this.title,
                    content: this.content,
                    postId: this.postId,
                    parentId: this.parentId,
                    url: this.postURL,
                    receivers: receivers,
                    images: JSON.stringify(this.media),
                    objectType: this.objectType,
                    tags: this.tags
                }

                if (this.postId != null) {
                    post.objectType = this.edittingPost.objectType;
                    post.objectId = this.edittingPost.objectId;
                }
                /*
                                if (post.objectType == 0) {
                                    post.receivers = '0';
                                }
                */
                axios.post(process.env.VUE_APP_API_URL + "/post/save", post).then(
                    data => {
                        if (data.success) {
                            this.page = 1;
                            this.content = "";
                            this.title = "";
                            this.media = [];
                            this.postURL = null;
                            this.tags = "";
                            this.getPost();
                            this.editting = false;
                            message.success("Đăng bài thành công");
                            if (this.workingComponent != null) {
                                this.workingComponent.getComment();
                                this.workingComponent = null;
                            }
                        } else {
                            message.error(data.description);
                        }
                    },
                    error => {
                        message.success(error);
                    }
                )
            },

            onEdit: function (item) {
                this.edittingPost = item;
                this.postId = item.postId;
                this.media = JSON.parse(item.images);
                if (this.media == null) {
                    this.media = [];
                }
                this.content = item.content;
                this.tags = item.tags;
                this.title = item.title;
                this.parentId = item.parentId;
                this.postURL = item.url;
                let arr = item.receivers.split(",");
                if (arr.length > 0) {
                    this.receivers = [];
                    for (let i = 0; i < arr.length; i++) {
                        this.receivers.push(parseInt(arr[i]));
                    }
                }
                this.editting = true;
            },

            onEditComment: function (item, component) {
                //console.log(item);
                this.workingComponent = component;
                this.edittingPost = item;
                this.postId = item.postId;
                this.postURL = item.url;
                this.media = JSON.parse(item.images);
                if (this.media == null) {
                    this.media = [];
                }
                this.content = item.content;
                this.tags = item.tags;
                this.title = item.title;
                this.parentId = item.parentId;
                this.editting = true;
            },

            onView: function (item) {
                this.$emit("view", item);
            },

            viewMember(rcv) {
                this.receiverOfPost = [];
                if (rcv != null && rcv != "") {
                    if (rcv == "0") {
                        this.receiverOfPost = this.lstStudents;
                    } else {
                        let members = rcv.split(",");
                        for (let j = 0; j < members.length; j++) {
                            for (let i = 0; i < this.lstStudents.length; i++) {
                                if (members[j] == this.lstStudents[i].userId) {
                                    this.receiverOfPost.push(this.lstStudents[i]);
                                    break;
                                }
                            }
                        }
                    }
                }
                this.showReceivers = true;
            },

            onViewExercise: function (item) {
                this.$emit("exercise_report", item);
            },

            onViewReport: function (item) {
                this.$emit("report", item);
            },

            cancelEdit: function () {
                this.postId = null;
                this.media = [];
                this.content = "";
                this.title = "";
                this.tags = "";
                this.workingComponent = null;
                this.parentId = null;
                this.editting = false;
                this.postURL = null;
            },

            deleteAttach: function (item) {
                for (let i = 0; i < this.media.length; i++) {
                    if (this.media[i].url == item.url) {
                        this.media.splice(i, 1);
                        break;
                    }
                }
            },

            onReload: function () {
                this.getTopPost();
                this.getPost();
            },

            onPaste: function (event) {
                let pasteData = event.clipboardData.getData('Text');
                ////console.log(pasteData);
                if (pasteData.toLowerCase().indexOf("http://") >= 0 || pasteData.toLowerCase().indexOf("https://") >= 0) {
                    let urlForm = {
                        "url": pasteData
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/post/urlParse", urlForm).then(
                        data => {
                            /*
                                                        this.title = data.title;
                                                        this.content = data.content;
                            */
                            if (data.images != undefined && data.images != null) {
                                this.media = JSON.parse(data.images);
                                ////console.log(this.media);
                            }
                            //this.postId = null;
                            this.postURL = data.url;
                        },
                        error => {

                        }
                    );

                }
            },

            getMemberList: function (name) {
                axios.post(process.env.VUE_APP_API_URL + "/classmember/myStudents?classId=" + this.classId + "&name=" + name).then(
                    data => {
                        //console.log(data);
                        this.memberTags = data;
                    },
                    error => {

                    }
                )
            },

            onKeyDown: function (e) {
                let start = e.target.selectionStart;
                ////console.log(this.content);
                this.st = "";
                for (let i = start; i >= 0; i--) {
                    if (this.content.charAt(i) == ' ' || this.content.charAt(i) == ' ' || this.content.charAt(i) == "\n" || this.content.charAt(i) == "\r") {
                        break;
                    } else if (this.content.charAt(i) == '@') {
                        //if (i == 0 || this.content.charAt(i - 1) == ' ' || this.content.charAt(i - 1) == '  ' || this.content.charAt(i)== "\n"|| this.content.charAt(i)== "\r") {
                        ////console.log("@ index is "+i);
                        ////console.log(this.content.charAt(i-1));
                        this.st = this.content.substring(i + 1, start);
                        //console.log(this.st);
                        break;
                        //
                    }
                }
                if (this.st != "") {
                    axios.post(process.env.VUE_APP_API_URL + "/classmember/member?classId=" + this.classId + "&name=" + this.st).then(
                        data => {
                            this.memberTags = data;
                            if (this.memberTags.length > 0) {
                                let dialog = document.querySelector(".v-dialog--active");
                                ////console.log(dialog);
                                let textArea = dialog.querySelector("#textArea");
                                /*
                                //console.log(textArea);
                                //console.log(dialog);
                                let textArea = dialog.getElementById("textArea");
                                */
                                let position = this.getCaretPosition(textArea);
                                //console.log(position);
                                let tag = document.getElementById("tagSelect");
                                tag.style.top = (position.y + 10) + "px";
                                tag.style.left = (position.x + 10) + "px";
                                tag.style.display = "";
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    )
                }

            },

            loadMore: function () {
                let page = Math.floor(this.posts.length / this.pageSize) + 1;
                ////console.log(this.posts);
                ////console.log(this.posts.length/ this.pageSize);
                ////console.log(page);
                let url = process.env.VUE_APP_API_URL + "/post/onSearch?classId=" + this.classId + "&objectType=" + this.objectType + "&page=" + page + "&pageSize=" + this.pageSize;
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.postCount = data.count;
                        for (let i = 0; i < data.items.length; i++) {
                            let bDuplicate = false;
                            for (let j = this.posts.length - 1; j >= 0; j--) {
                                if (data.items[i].postId == this.posts[j].postId) {
                                    bDuplicate = true;
                                    break;
                                }
                            }
                            if (!bDuplicate) {
                                this.posts.push(data.items[i]);
                            }
                        }
                    },
                    error => {

                    }
                )
            },

            getTopPost: function () {
                //console.log("SDfsdfsdfsd");
                let url = process.env.VUE_APP_API_URL + "/post/onSearchTop?classId=" + this.classId + "&objectType=" + this.objectType + "&page=1&pageSize=-1";

                axios.post(url).then(
                    data => {
                        //console.log("after get post");
                        this.topPosts = data.items;
                        //console.log(this.topPosts);
                    },
                    error => {

                    }
                )
            },

            getPost: function () {
                let url = process.env.VUE_APP_API_URL + "/post/onSearch?classId=" + this.classId + "&objectType=" + this.objectType + "&page=" + this.page + "&pageSize=" + this.pageSize;
                ////console.log(this.search);
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }

                axios.post(url).then(
                    data => {
                        this.postCount = data.count;
                        this.posts = data.items;
                        ////console.log(this.posts);
                    },
                    error => {

                    }
                )
            },

            openFileDialog() {
                document.getElementById("imageUpload" + this.objectType).click();
            },

            uploadFile: function () {
                let formData = new FormData();
                if (this.media.length == 9) {
                    message.error("Chỉ được phép tải lên không quá 9 file ảnh, video hoặc tài liệu");
                    return;
                }
                formData.append("uploadfile", this.fileContent);
                formData.append("sourceId", "");
                formData.append("sourceType", "1");
                formData.append("attachTitle", "");
                axios.post(process.env.VUE_APP_API_URL + "/upload/save", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(
                    data => {
                        ////console.log(data);
                        let md = {
                            url: process.env.VUE_APP_API_URL + "/download/attach/" + data.id,
                            type: this.fileType,
                            fileName: this.fileName
                        }
                        this.media.push(md);
                        //console.log("--- editing ---");
                        //console.log(this.editting);
                        if (!this.editting) {
                            this.editting = true;
                        }
                        ////console.log(this.media);
                    },
                    error => {
                        message.error("upload failed");
                    }
                );
            },

            onFilePicked: function (e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    ////console.log(files[0]);
                    this.fileName = files[0].name;
                    this.fileType = files[0].type;
                    if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.fileURL = fr.result;
                        this.fileContent = files[0]; // this is an file that can be sent to server...
                        this.uploadFile();
                    })
                }
            },

            getClassOfImage: function (item) {
                if (item.title != undefined && item.title != null && item.t != "") {
                    return "imageUrl";
                } else {
                    return "imagePost";
                }
            },

            tagUser: function (item) {
                this.content = this.content.replace("@" + this.st, item.fullName);
                if (this.tags == null || this.tags == "") {
                    this.tags = item.userId;
                } else {
                    this.tags += "," + item.userId;
                }
                document.getElementById("tagSelect").style.display = "none";
            },

            createCopy: function (textArea) {
                let pos = this.getAbsPosition(textArea);
                //console.log(textArea);
                let copy = document.createElement('div');
                copy.textContent = textArea.value;
                let style = getComputedStyle(textArea);
                [
                    'fontFamily',
                    'fontSize',
                    'fontWeight',
                    'wordWrap',
                    'whiteSpace',
                    'borderLeftWidth',
                    'borderTopWidth',
                    'borderRightWidth',
                    'borderBottomWidth',
                ].forEach(function (key) {
                    copy.style[key] = style[key];
                });
                copy.style.overflow = 'auto';
                copy.style.width = textArea.offsetWidth + 'px';
                copy.style.height = textArea.offsetHeight + 'px';
                copy.style.position = 'absolute';
                copy.style.left = pos.x + 'px';
                copy.style.top = pos.y + 'px';
                //copy.style.backgroundColor = "red";
                document.body.appendChild(copy);
                return copy;
            },

            getAbsPosition: function (el) {
                //console.log(el.style.display);
                for (var lx = 0, ly = 0; el != null;) {
                    let rect = el.getBoundingClientRect();
                    //console.log(rect);
                    lx += el.offsetLeft;
                    ly += el.offsetTop;
                    el = el.offsetParent;
                }
                ;
                let pos = {x: lx, y: ly};
                //console.log(pos);
                return pos;
            },

            getCaretPosition: function (textArea) {
                var start = textArea.selectionStart;
                var end = textArea.selectionEnd;
                var copy = this.createCopy(textArea);
                var range = document.createRange();
                //console.log(range);
                range.setStart(copy.firstChild, start);
                range.setEnd(copy.firstChild, end);
                var selection = document.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                var rect = range.getBoundingClientRect();
                document.body.removeChild(copy);
                textArea.selectionStart = start;
                textArea.selectionEnd = end;
                textArea.focus();
                //console.log(rect);
                //console.log(textArea.scrollLeft);
                //console.log(textArea.scrollTop);
                return {
                    x: rect.left - textArea.scrollLeft,
                    y: rect.top - textArea.scrollTop
                };
            },

        }
    };
</script>